"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.stackedWithGroupsLayoutRenderer = void 0;
const React = __importStar(require("react"));
const Contexts = __importStar(require("../contexts"));
const group_renderer_1 = require("./group-renderer");
const genesys_properties_selector_helpers_1 = require("../genesys-properties-selector-helpers");
const stackedWithGroupsLayoutRenderer = (props) => {
    const selectorInfoMap = (0, genesys_properties_selector_helpers_1.createSelectorInfoMap)(props.selectors);
    return (React.createElement(Contexts.propertiesSelectorContext.Consumer, null, ({ activatedQuantitySelectors, conversionParametersMap, filterPrettyPrint, onQuantityChange, layoutRendererExtraProps, showGroups, translatePropertyValue }) => {
        if (layoutRendererExtraProps.sections.length === 0) {
            return React.createElement("div", null);
        }
        const groups = layoutRendererExtraProps.sections[0].groups.map(group => (React.createElement(group_renderer_1.GroupRenderer, { key: `${layoutRendererExtraProps.uniqueId}-${group.key}`, fieldGroup: layoutRendererExtraProps.fieldGroup, filterPrettyPrint: filterPrettyPrint, renderGroup: group, showGroups: showGroups, hidePropertyNames: layoutRendererExtraProps.hidePropertyNames, rowRendererType: {
                type: "StandardRowRenderer",
                translatePropertyValue: translatePropertyValue
            }, selectorInfoMap: selectorInfoMap, activatedQuantitySelectors: activatedQuantitySelectors, onQuantityChange: onQuantityChange, conversionParametersMap: conversionParametersMap })));
        return React.createElement("div", null, groups);
    }));
};
exports.stackedWithGroupsLayoutRenderer = stackedWithGroupsLayoutRenderer;
//# sourceMappingURL=stacked-with-groups-layout-renderer.js.map